// Copyright (c) 2016 Deere & Company

import PartReturnStatus, {getDefaultState as getPartReturnStatusDefaultState} from './part-return-status';
import t from 'tcomb';

const PartReturnSettings = t.struct({
    numberOfDays: t.Number,
    status: PartReturnStatus
}, {
    name: 'PartReturnSettings',
    strict: true
});

export const getDefaultState = () => new PartReturnSettings({
    numberOfDays: 0,
    status: getPartReturnStatusDefaultState()
});

export default PartReturnSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/part-return-settings.js